import { useState, useEffect } from 'react';
import { shutdownCitiesQuery } from '../../../../../shared/api/queries';
import {
  shutdownEmitter as emitter,
  shutdownEvtNames,
} from '../../../../../shared/constants';
import { fieldNames } from '../../config';
import useCompanies from '../../../../../../../queries/useCompanies';

const { setDraftSelectValueBuilder, newCityValue, newCompanyValue } =
  shutdownEvtNames;
const { useShutdownCities } = shutdownCitiesQuery;
const cityFieldName = fieldNames.city;
const companyFieldName = fieldNames.company;

const valueTypes = {
  number: 'number',
  arrayNumber: 'arrayNumber',
};

const getValueByTypeMethods = {
  [valueTypes.number]: (value, data) => {
    if (value === undefined || value === null) return value;
    const item = data?.find((i) => i.id === value);
    return item ? value : undefined;
  },

  [valueTypes.arrayNumber]: (value, data) => {
    const isEmpty = !value || (Array.isArray(value) && !value.length);
    if (isEmpty) return [];
    return value.filter((valueItem) =>
      data?.some((dataItem) => dataItem.id === valueItem)
    );
  },
};

const useSetSelectValueSubscription = ({
  fieldName,
  data,
  valueType,
  cb,
  form,
}) => {
  useEffect(() => {
    const handler = (value) => {
      if (data?.length) {
        typeof cb === 'function'
          ? cb(value)
          : form.setFieldsValue({
              [fieldName]: getValueByTypeMethods[valueType](value, data),
            });
      }
    };

    const name = setDraftSelectValueBuilder(fieldName);

    emitter.on(name, handler);

    return () => emitter.off(name, handler);
  }, [data, cb, fieldName, valueType]);
};

const useNewCompanyValueSubscription = () => {
  const [companyDependentData, setCompanyDependentData] = useState(null);

  useEffect(() => {
    emitter.on(newCompanyValue, setCompanyDependentData);
    return () => emitter.off(newCompanyValue, setCompanyDependentData);
  }, []);

  return companyDependentData;
};

const useNewCompanyValueEmitFormMount = ({ form }) => {
  const { data } = useCompanies({
    staleTime: Infinity,
  });

  useEffect(() => {
    if (data?.length === 1) {
      const newValue = { [companyFieldName]: data[0].id };
      form.setFieldsValue(newValue);
      emitter.emit(newCompanyValue, newValue);
    }
  }, [data]);
};

const useNewCityValueSubscription = () => {
  const [cityDependentData, setCityDependentData] = useState(null);

  useEffect(() => {
    emitter.on(newCityValue, setCityDependentData);
    return () => emitter.off(newCityValue, setCityDependentData);
  }, []);

  return cityDependentData;
};

const useNewCityValueEmitFormMount = ({ form }) => {
  const companyData = useNewCompanyValueSubscription();

  const companyId = companyData?.[companyFieldName];

  const { data } = useShutdownCities(companyId, {
    staleTime: Infinity,
    enabled: !!companyId,
  });

  useEffect(() => {
    if (data?.length === 1) {
      const newValue = { [cityFieldName]: data[0].id };
      form.setFieldsValue(newValue);
      emitter.emit(newCityValue, newValue);
    }
  }, [data]);
};

export {
  valueTypes,
  useSetSelectValueSubscription,
  useNewCityValueSubscription,
  useNewCityValueEmitFormMount,
  useNewCompanyValueEmitFormMount,
  useNewCompanyValueSubscription,
};
